import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { optionColor, optionColorHover } from '../../../helpers/shared';

// Define element styles for the component
const LinkText = styled.a`
  color: ${props => optionColor(props.color)};
  font-size: 15px;
  font-weight: 500;
  margin: 0;
  padding: 0;
  text-decoration: none;
  &:hover {
    color: ${props => optionColorHover(props.color)};
    transition: 200ms ease-in;
  }
`;

/**
 * Link component
 * @component
 * @param {Element} children
 * @returns
 */
export const Link = ({ children, ...props }) => {
  return <LinkText { ...props }>{ children }</LinkText>;
};

Link.propTypes = {
  children: PropTypes.any
};